import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PharmaorderEditFormImpl from './PharmaorderEditFormImpl';
import PharmaorderList from './PharmaorderList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PharmaorderListView from './PharmaorderListView'


export default function PharmaorderDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
  const [ pharmaorderId, setPharmaorderId] = React.useState('');
  const [reloadPharmaorderList, setReloadPharmaorderList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PharmaorderEditFormImpl 
            setReloadPharmaorderList={setReloadPharmaorderList}
            pharmaorderId={pharmaorderId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PharmaorderListView 
                      setPharmaorderId = {setPharmaorderId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
